export const selectCurrentUser = (state) => state.user.currentUser;
export const selectUid = (state) => state.user.uid;
export const selectLoading = (state) => state.user.loading;